import React from "react";
import { EvtStatsCard as StatsCard } from "components/stats/display-card";
import { EvtStatsCardLoader } from "components/stats/loader";
import { DisplayAmount } from "components/display/amount";
import { useBillableStats } from "../hooks/useBillableOverviewStats";


export function BillableOverviewCard({ status, label, info, dateRange }) {

  // Helper function to get the appropriate date filter for the status
  const getDateFilterForStatus = (status, dateRange) => {
    if (!dateRange) return undefined;

    const dateFilter = {
      _lte: dateRange.to,
      _gte: dateRange.from
    };

    switch (status) {
      case "contracted":
      case "pending_invoice":
        return { billing_date: dateFilter };
      case "billed":
        return { invoice_date: dateFilter };
      case "collected":
        return { collected_date: dateFilter };
      case "cancelled":
        return { billing_date: dateFilter };
      default:
        return { billing_date: dateFilter };
    }
  };

  const filters = getDateFilterForStatus(status, dateRange);
  const { data: stats, isLoading, error } = useBillableStats(status, filters);

  if (isLoading) {
    return <EvtStatsCardLoader />;
  }

  if (error) {
    return (
      <StatsCard
        label={label}
        value="Error loading data"
        className="text-red-500"
      />
    );
  }

  const totalAmount = stats?.totalAmount || 0;

  return (
    <StatsCard
      label={label}
      value={<DisplayAmount value={totalAmount} />}
      info={info}
    />
  );
}
